import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material';
import { useTranslation } from 'react-i18next';

function ConfirmationDialog({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
    confirmColor = 'primary',
}) {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title">
                {title || t('confirmationDialog.defaultTitle', 'Confirmar Acción')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {cancelText || t('confirmationDialog.cancelButton', 'Cancelar')}
                </Button>
                <Button onClick={onConfirm} color={confirmColor} autoFocus={confirmColor === 'primary'}>
                    {confirmText || t('confirmationDialog.confirmButton', 'Confirmar')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmationDialog; 